import React, { memo } from "react";

import cn from "classnames";

import EmailDynamicVariable from "@mapmycustomers/shared/types/email/EmailDynamicVariable";
import {
  EMAIL_DYNAMIC_VARIABLE_REGEX,
  parseEmailDynamicVariableMatch,
} from "@mapmycustomers/shared/util/email/parseEmailDynamicVariables";
import { splitStringByRegExp } from "@mapmycustomers/shared/util/stringUtils";
import { EmailDynamicVariableView } from "@mapmycustomers/ui";

import styles from "./EmailSubjectView.module.scss";

interface EmailSubjectViewProps {
  className?: string;
  dynamicVariableClassName?: string;
  dynamicVariables: EmailDynamicVariable[];
  greyed?: boolean;
  subject: string;
  textClassName?: string;
}

const EmailSubjectView = ({
  className,
  dynamicVariableClassName,
  dynamicVariables,
  greyed,
  subject,
  textClassName,
}: EmailSubjectViewProps) => {
  return (
    <span className={className}>
      {splitStringByRegExp(subject, EMAIL_DYNAMIC_VARIABLE_REGEX).map((part, index) => {
        switch (part.type) {
          case "text": {
            return (
              <span className={cn({ [styles.greyed]: greyed }, textClassName)} key={index}>
                {part.text}
              </span>
            );
          }
          case "match": {
            const { entityType, name, prefix } = parseEmailDynamicVariableMatch(part.match);

            const dynamicVariable = dynamicVariables.find(
              (dynamicVariable) =>
                dynamicVariable.prefix === prefix && dynamicVariable.name === name
            );

            if (!dynamicVariable) {
              return null;
            }

            return (
              <EmailDynamicVariableView
                className={dynamicVariableClassName}
                dynamicVariable={dynamicVariable}
                entityType={entityType}
                greyed={greyed}
                key={index}
              />
            );
          }
        }
      })}
    </span>
  );
};

export default memo(EmailSubjectView);
